import { Filter } from '@Types';

export const buildSearchQueryParam = (
	params: Record<string, unknown>,
): string => {
	const criteria = Object.entries(params).map(([key, value]) =>
		value ? `${key}:${value}` : null,
	);
	return criteria.filter(el => !!el).join(',');
};

export const parseSearchFiltersWithOptions = (filters: {
	[key: string]: Filter;
}) => {
	return Object.entries(filters).reduce(
		(acc, [key, { selected, options }]) => {
			let value = null;
			if (!options || selected !== options[0]) value = selected;
			return { ...acc, [key]: value };
		},
		{},
	);
};
